import api from "./api";

/**
 * Müşteri (CRM) uçları (backend: /api/customers). Yanıtlar ApiResponse zarfında
 * gelir (res.data.data). Liste Spring Pageable döner: { content, totalElements, ... }.
 */
export const customerService = {
  list: (params = {}) => api.get("/customers", { params }),
  get: (id) => api.get(`/customers/${id}`),
  create: (payload) => api.post("/customers", payload),
  update: (id, payload) => api.put(`/customers/${id}`, payload),
  remove: (id) => api.delete(`/customers/${id}`), // soft delete (pasife al)
  hardRemove: (id) => api.delete(`/customers/${id}`, { params: { hard: true } }), // kalıcı sil
  setActive: (id, active) => api.patch(`/customers/${id}/status`, null, { params: { active } }),
};
